export default "__VITE_ASSET__CzePO10j__"